<template>
  <header class="header">
    <div class="flex-row flex-row--end">
      <nav-dots/>
      <img class="header__logo header__logo-clickable" src="../assets/img/decisionvue-logo.svg" alt="DecisionVue" @click="nav2map"/>
    </div>
    <div class="flex-row">
      <img class="header__logo center" src="../assets/img/wsp-logo.png" alt="WSP"/>
    </div>
    <div class="flex-row flex-row--end">
      <div class="ping-dropdown" v-if="pingEnabled">
        <div class="ping-dropbtn">
<i class="fas fa-comments"></i>
          <!-- <img src="../assets/img/message-star-svgrepo-com.svg" alt="PowerBI" class="ping-icon" /> -->
        </div>
        <div class="ping-dropdown-content">
          <a :href="pingReportsUrl" target="_blank">Reports</a>
          <a :href="pingAdminUrl" target="_blank">Admin Tool</a>
        </div>
      </div>
      <UserButton/>
    </div>
  </header>
</template>

<script>
  import NavDots from './NavDots.vue'
  import UserButton from './UserButton.vue';
  export default {
    name: 'HeaderComponent',
    components: { UserButton, NavDots },
    data() { return {} },
    computed: {
      config() {
        return this.$store.getters.config;
      },
      pingEnabled() {
        return this.config && 
               this.config.optionalFeatures && 
               this.config.optionalFeatures.headerActions && 
               this.config.optionalFeatures.headerActions.ping && 
               this.config.optionalFeatures.headerActions.ping.enabled;
      },
      pingReportsUrl() {
        return this.pingEnabled && 
                this.config.optionalFeatures.headerActions.ping.reportsUrl
               ? this.config.optionalFeatures.headerActions.ping.reportsUrl 
               : '';
      },
      pingAdminUrl() {
        return this.pingEnabled && 
                this.config.optionalFeatures.headerActions.ping.adminUrl
               ? this.config.optionalFeatures.headerActions.ping.adminUrl 
               : '';
      }
    },
    methods: {
      nav2map: function() {
        this.$router.push({ name: 'map' });
      },
    },
  }
</script>
<style scoped>

.ping-dropdown {
  position: relative;
  display: inline-block;
}

.ping-dropbtn {
  color: white;
  padding: 2px 4px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

.ping-dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 120px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 2000;
  right: 0px;
  top: 100%;
}

.ping-dropdown::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  height: 8px;
}

.ping-dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.ping-dropdown-content a:hover {
  background-color: #ddd;
}

.ping-dropdown:hover .ping-dropdown-content {
  display: block;
}

.ping-icon {
  width: 24px;
  height: 24px;
  display: block;
  cursor: pointer;
}

.ping-icon:hover {
  opacity: 0.8;
}
</style>